import one from '../assets/svg/projects/DIZYNER.jpg'
import two from '../assets/svg/projects/LyneAPI.jpg'
import three from '../assets/svg/projects/Coinhomes1.jpeg'
import four from '../assets/svg/projects/Shortlyst.jpeg'
import five from '../assets/svg/projects/dallali-img.png'
import six from '../assets/svg/projects/DDSA.jpeg'


export const projectsData = [
    {
        id: 1,
        projectName: 'DIZYNER - open marketplace and fashion design social media',
        projectDesc: 'Dizyner is an open marketplace and fashion social media.',
        tags: ['Flask', 'HTML' ,'CSS', 'Javascript'],
        code: '',
        demo: 'https://dizyner.com/',
        image: one
    },
    {
        id: 2,
        projectName: 'Lyne API Portal',
        projectDesc: 'Lyne API Portal created using Python-Django and implemented into docker and Deployed with AWS',
        tags: ['Python', 'Docker', 'AWS', "MySQL", "Django"],
        code: 'https://github.com/sreerag-rajan/educative-clone',
        demo: 'https://dashboard.lyne.ai/',
        image: two
    },
    {
        id: 3,
        projectName: 'Coinhomes',
        projectDesc: 'Coin Homes is the first platform in North America that empowers you with inspiration, tools and knowledge to purchase real estate with Bitcoin.',
        tags: ['React','Express','MongoDB','NodeJS','Firebase'],
        code: '',
        demo: 'https://coinhomes-v2.web.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'ShortLyst',
        projectDesc: 'ShorLyst is USA based online job portal.',
        tags: ['React', 'Express', 'MongoDB', 'NodeJS', 'AWS'],
        code: '',
        demo: 'https://app.getshortlyst.com/',
        image: four
    },
    {
        id: 5,
        projectName: 'Dallali - Property Management',
        projectDesc: 'a licensed and integrated platform for real estate brokers to streamline their real estate activities with automated digital solutions.',
        tags: ['NextJs', 'Python', 'Postgres', 'AWS'],
        code: '',
        demo: 'https://app.getshortlyst.com/',
        image: five
    },
    {
        id: 6,
        projectName: 'DDSA - Tennis Scout admin',
        projectDesc: 'DDSA tennis court is an one kind of admin panel which is stored all player tournament data from CSV to real-time dashboard and managing all player tournament data.',
        tags: ['ReactJS', 'HTML', 'CSS' ,'Redux'],
        code: '',
        demo: '',
        image: six
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/